// extracted by mini-css-extract-plugin
export var art = "DepositSuccess-module--art--75fd4";
export var button = "DepositSuccess-module--button--458cc";
export var container = "DepositSuccess-module--container--6d37a";
export var done = "DepositSuccess-module--done--b2361";
export var title = "DepositSuccess-module--title--54c37";